import React, { Component } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

function getStoredToken(): string {
  try {
    const raw = localStorage.getItem('token');
    if (!raw) return '';
    return JSON.parse(raw) as string;
  } catch {
    return '';
  }
}

export default class AppelsCourts extends Component<{}, IAppelsCourtsDataStructure> {
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = { data: [] };
  }

  componentDidMount() {
    const base = process.env.REACT_APP_API_URL || '';
    const token = getStoredToken();
    const path = '/api/short_calls_date/2023-12-01/2023-12-31/0/5';
    fetch(`${base.replace(/\/$/, '')}${path}`, {
      headers: {
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.setState({ data: Array.isArray(data) ? data : [] });
      })
      .catch(() => {
        this.setState({ data: [] });
      });
  }

  render() {
    const { data } = this.state;
    return (
      <ResponsiveContainer width="80%" height="80%">
        <LineChart width={500} height={300} data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="hour" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="FKTEL_100000001" stroke="red" />
          <Line type="monotone" dataKey="UNIMOB_73222" stroke="green" />
          <Line type="monotone" dataKey="FKTEL_100000010" stroke="red" />
          <Line type="monotone" dataKey="UNIMOB_73204" stroke="green" />
          <Line type="monotone" dataKey="FKTEL_100000002" stroke="red" />
        </LineChart>
      </ResponsiveContainer>
    );
  }
}

interface IAppelsCourtsDataStructure {
  data: object[];
}
